import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DatePicker } from "../../Components/Common/Flatpicker";
import TeamSelect from "../../Components/Common/TeamSelect";
import EmployeeSelect from "../../Components/Common/EmployeeSelect";
import { getPreviousDate } from "../../Components/Common/DefaultDateSet";
import { addMonths } from "../../Components/Common/FlatePicker";
import ConsolidatedTable from "./ConsolidatedTable";

const ConsolidatedReport = () => {
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const previewsDate = getPreviousDate();
  const currentDate = getPreviousDate();

  // State management
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
  const [selectedToDate, setSelectedToDate] = useState(currentDate);
  const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
  const [teamIndu, setTeamIndu] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);

  // Maintain a single source of truth for filters
  const [appliedFilters, setAppliedFilters] = useState({
    fromDate: selectedFromDate,
    toDate: selectedToDate,
    employees: [],
    team: [],
  });
  const [employee,setEmployee] = useState(appliedFilters?.employees)

  // Date range validation
  const isWithinRange = (date) => {
    const today = new Date();
    return date >= selectedFromDate && date <= today;
  };

  // Handle date changes
 const handleFromDateChange = (dates) => {
  const newFromDate = dates[0];
  setSelectedFromDate(newFromDate);
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  const threeMonthsAfterFromDate = addMonths(newFromDate, 3);

  if (selectedToDate >= newFromDate && selectedToDate <= threeMonthsAfterFromDate) {
    return; 
  }
  
  const newToDate = threeMonthsAfterFromDate > today ? today : threeMonthsAfterFromDate;
  setSelectedToDate(newToDate);
};

  const handleToDateChange = (dates) => {
    const newToDate = dates[0];
    if (isWithinRange(newToDate)) {
      setSelectedToDate(newToDate);
    }
  };

  // Handle form submission
  const handleSubmit = () => {
    if(selectedEmployeeOptions.length === 0 && loginType === "organization")
    {
      setError("Please select at least one employee");
    }
    else{
      setSelectedEmployeeOptions(appliedFilters?.employees)
      setAppliedFilters({
        fromDate: selectedFromDate,
        toDate: selectedToDate,
        employees: selectedEmployeeOptions ,
        team: teamIndu,
      });
      setError("")
    }
  };

  // Reset form
  const resetInputHistory = () => {
    setSelectedToDate("");
    setSelectedFromDate("");
    setSelectedEmployeeOptions([]);
    setTeamIndu([]);
    // setAppliedFilters({
    //   fromDate: "",
    //   toDate: "",
    //   employees: [],
    //   team: [],
    // });
  };

  // Keep selectedEmployeeOptions in sync with appliedFilters
  useEffect(() => {
    if (appliedFilters.employees.length > 0 && appliedFilters.employees !== selectedEmployeeOptions) {
      setSelectedEmployeeOptions(appliedFilters.employees);
    }
  }, [appliedFilters.employees]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Consolidate Report" pageTitle="Consolidate Report" />
        <Row>
          <Col lg={12}>
            <Card className="h-100">
              <CardBody>
                <Row className="sn-header-select-employess-home sn-top-inputs-heading">
                  <div className="col-md-2 col-sm-12">
                    <DatePicker
                      labelContent="From Date"
                      getDate={selectedFromDate}
                      options={{
                        disable: [{ from: new Date() }],
                        dateFormat: "d M, Y",
                        maxDate: new Date(new Date().setDate(new Date().getDate())),
                      }}
                      onChange={handleFromDateChange}
                    />
                  </div>

                  <div className="col-md-2 col-sm-12">
                    <DatePicker
                      labelContent="To Date"
                      getDate={selectedToDate}
                      options={{
                        dateFormat: "d M, Y",
                        minDate: selectedFromDate,
                        enable: [{
                          from: selectedFromDate,
                          to: Math.min(addMonths(selectedFromDate, 3), new Date())
                        }],
                        onOpen: () => {
                          const currentDate = new Date();
                          const threeMonthsFromStart = addMonths(selectedFromDate, 3);
                          if (threeMonthsFromStart > currentDate) {
                            return {
                              enable: [{
                                from: selectedFromDate,
                                to: currentDate,
                              }],
                            };
                          }
                        },
                      }}
                      onChange={handleToDateChange}
                    />
                  </div>

                  {((viewReportPermission && loginType === "employee") ||
                    loginType === "organization") && (
                    <div className="col-md-2 col-sm-12">
                      <TeamSelect
                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                        teamIndu={teamIndu}
                        setTeamIndu={setTeamIndu}
                        labelContent="Select Team"
                      />
                    </div>
                  )}

                  {((viewReportPermission && loginType === "employee") ||
                    loginType === "organization") && (
                    <div className="col-md-3 col-sm-12">
                      <EmployeeSelect
                        error={error}
                        setError={setError}
                        EmployeeDefault={employeeData}
                        setEmployeeDefault={setEmployeeData}
                        teamIndu={teamIndu}
                        selectedEmployeeOptions={selectedEmployeeOptions}
                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                        labelContent="Select Employee"
                        newFilters={employee}
                        setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                      />
                    </div>
                  )}

                  <div className="col-md-3 col-sm-12">
                    <FormGroup className="mt-2">
                      <Label for="exampleSelect"></Label>
                      <div className="sn-call-apply-btn-reset">
                        <Button
                          type="submit"
                          color="danger"
                          onClick={handleSubmit}
                          disabled={isLoading}
                        >
                          Apply
                        </Button>
                        <Button
                          className="ms-2"
                          outline
                          color="danger"
                          onClick={resetInputHistory}
                          disabled={isLoading}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </div>
                </Row>

                <div className="d-flex sn-report-consolidate-reporttble">
                  <ConsolidatedTable 
                    selectedFromDate={selectedFromDate}
                    setSelectedFromDate={setSelectedFromDate}
                    setSelectedToDate={setSelectedToDate}
                    selectedToDate={selectedToDate}
                    selectedEmployeeOptions={selectedEmployeeOptions}
                    setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                    teamIndu={teamIndu}
                    appliedFilters={appliedFilters}
                    setTeamIndu={setTeamIndu}
                    selectedEmployeeOptions2={selectedEmployeeOptions2}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ConsolidatedReport;